/* istanbul ignore next */
(function (angular) {
	'use strict';
	angular.module('bm.practice.timeAndExpense', [
        'bluemoon.components.analytics',
        'time.and.expense.templates',
                'bm.practice.common.templates',
                'bmpAmountLimitsService',
        'bm.practice.timeAndExpense.TimeAndExpensePageController',
        'bm.practice.timeAndExpense.TimeAndExpenseEntryForm',
        'bm.practice.timeAndExpense.TimeAndExpenseDailyEntryController',
        'bm.practice.timeAndExpense.TimeAndExpenseEntry',
        'bm.practice.timeAndExpense.TimeAndExpenseRecapProvider',
        'bm.practice.timeAndExpense.ReviewController',
        'bm.practice.timeAndExpense.GridEntry',
        'bm.practice.timeAndExpense.TimeAndExpenseGridEntry',
        'bm.practice.timeAndExpense.ActivityLog'
	]);
}(window.angular));
